<template>
    <div id="login">
        <div class="login-con">
            <div class="tips">
                <h3>用户登录</h3>
            </div>
            <div class="login-info">
                <el-form ref="loginForm" :model="user" :rules="regRules" status-icon size="medium" label-width="100px">
                    <el-form-item label="手机号：" prop="phone">
                        <el-input maxlength="11" placeholder="请输入手机号" prefix-icon="el-icon-mobile-phone"
                            v-model.trim="user.phone"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码：" prop="code">
                        <el-input maxlength="6" placeholder="请输入短信验证码" prefix-icon="el-icon-unlock" style="width: 60%"
                            v-model="user.code" @keyup.enter.native="userLogin"></el-input>
                        <el-button class="code" style="margin-left: 4.4%; width: 34%" :disabled="isCountdown" @click="sendCode">
                            <label v-show="!isCountdown">获取验证码</label>
                            <label v-show="isCountdown">{{ count }}s</label>
                        </el-button>
                    </el-form-item>
                    <el-form-item width="0">
                        <el-checkbox v-model="user.radio">已阅读并同意<span style="color: #5680FA;" @click="dealClick">《用户服务协议》</span>及<span style="color: #5680FA;" @click="goPrivacy">《隐私政策》</span></el-checkbox>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" style="width: 100%;background-color: #5680FA;border-color: #5680FA" @click="userLogin">
                            登录
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import MD5 from "../../assets/js/MD5.js";
import { Bus } from "../../tools/bus";
export default {
    name: "Login",
    data() {
        return {
            count: 0,
            isCountdown: false,
            timer: null,
            user: {
                phone: "",
                code: "",
                radio: false,
            },
            regRules: {
                phone: [
                    {
                        required: true,
                        trigger: "blur",
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error("请输入手机号"));
                            } else {
                                let reg = /^1[3-9]\d{9}$/;
                                reg.test(value) ? callback() : callback(new Error("手机号格式有误"));
                            }
                        }
                    }
                ],
                code: [
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: "change",
                        pattern: /^\d{4,6}$/
                    }
                ]
            },
        };
    },
    created() {
        if (!localStorage.getItem("userId")) {
            setTimeout(() => {
                localStorage.clear();
            }, 1000);
        }
    },
    methods: {
        /**
         *
         * 获取个人详情信息
         */
        getUserInfo(userSelectGid) {
            this.$axios
                .post("/web/user/select", this.$qs.stringify({ chGid: "", userSelectGid }))
                .then(res => {
                    let data = res.data;
                    if (data.code == "1") {
                        let avatars = data.result_data[0].avatars;
                        let isConfirm = data.result_data[0]["approveStatus"];
                        let status = data.result_data[0].approveStatus;
                        sessionStorage.setItem("userAvatar", avatars||"");

                        localStorage.setItem("isConfirm", isConfirm);

                        // 来源地址：从需要登录的页面跳转登录时携带
                        let redirect = this.$route.query.redirect;

                        if (sessionStorage.getItem("RedirectPage")) {
                            sessionStorage.removeItem("RedirectPage");
                            this.$router.go(-1);
                        }else if(redirect){
                            // 从需要登录的页面跳转而来：已认证直接返回该页面，未认证先去认证页(携带回跳地址)
                            this.$router.replace(status == 0 ? { path: "/register", query: { redirect } } : redirect);
                        }else if(status=='1'||status=='2'){
                            this.$router.push("/");
                        }else {
                            this.$router.push("/register");
                        }
                    }
                })
                .catch(err => {
                });
        },
        getValidCode(mobile, token) {
            let codeToken = MD5(MD5(token) + "123qwe!@#");
            this.$axios
                .post("/web/user/receiveIdentityCode", this.$qs.stringify({ mobile, codeToken }))
                .then(res => {
                    let data = res.data;
                    if (data.code == "1") {
                        this.$message({
                            message: "发送成功！",
                            type: "success"
                        });
                    } else {
                        this.$message({
                            message: data.message,
                            type: "warning"
                        });
                    }
                })
                .catch(err => {
                });
        },
        sendCode() {
            this.$refs.loginForm.validateField("phone", valid => {
                if (valid) return false;
                let mobile = this.user.phone;
                this.$axios
                    .post("/web/user/getValidToken", this.$qs.stringify({ mobile }))
                    .then(res => {
                        let data = res.data;
                        if (data.code == "1") {
                            let token = data.result_data.token;
                            token ? this.getValidCode(mobile, token) : this.$message.error("没有正确获得口令");
                        } else {
                            this.$message({
                                message: data.message,
                                type: "warning"
                            });
                        }
                    })
                    .catch(err => {
                    });

                this.isCountdown = false;
                const TIME_COUNT = 60;
                if (!this.timer) {
                    this.count = TIME_COUNT;
                    this.isCountdown = true;
                    this.timer = setInterval(() => {
                        if (this.count > 0 && this.count <= TIME_COUNT) {
                            this.count--;
                        } else {
                            this.isCountdown = false;
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                    }, 1000);
                }
            });
        },
        /**
         * 登录
         */
        userLogin() {


            if (this.user.radio) {


                // return
                this.$refs.loginForm.validate(valid => {
                    if (!valid) return false;
                    let mobile = this.user.phone,
                        identityCode = this.user.code;
                    this.$axios
                        .post("/web/user/loginByMessage", this.$qs.stringify({ mobile, identityCode }))
                        .then(res => {
                            let data = res.data;
                            if (data.code == "1") {
                                let userInfo = data.result_data;
                                localStorage.setItem("token", userInfo.token);
                                localStorage.setItem("userId", userInfo.userId);
                                this.$message({
                                    message: data.message,
                                    type: "success"
                                });
                                this.getUserInfo(userInfo.userId);
                                Bus.$emit("setToken", true);
                            } else if (data.code == "0" && data.message) {
                                this.$message({
                                    message: data.message,
                                    type: "warning"
                                });
                            } else {
                                this.$message.error("验证码输入错误");
                            }
                        })
                        .catch(err => {
                        });
                });

            } else {

                this.$message.error("请先勾选用户协议和隐私政策");


            }

        },
        getSetItem(){
            var loginData = this.user
            sessionStorage.setItem('loginData',JSON.stringify(loginData))
        },
        dealClick(){
            this.getSetItem()
            window.location.href = "http://app.orthoday.com/deal.html";
        },

        goPrivacy() {
            this.getSetItem()
            window.location.href = "http://app.orthoday.com/gjzw_privacyPolicy.html";
        },
    },
    beforeRouteEnter(to, from, next) {
        next((vm)=>{
            //跳转到协议/政策页面或者刷新本页面时
            if(from.name==null&&sessionStorage.getItem('loginData')){
                vm.user = JSON.parse(sessionStorage.getItem('loginData'))
            }else{
                // 其他页面时
                sessionStorage.setItem('loginData','')
            }
        })
    },
};
</script>

<style scoped src="../../assets/css/login-reg.css">

.bigClick{
    color: blue;
}
</style>
<style scoped>
    .el-checkbox.is-checked /deep/ .el-checkbox__input .el-checkbox__inner{
        border-color:#5680FA;
        background-color:#5680FA
    }
    .el-checkbox.is-checked /deep/ .el-checkbox__label{
        color: #5680FA;
    }
    .el-checkbox /deep/ .el-checkbox__inner:hover{
        border-color:#5680FA;
    }
    .el-input /deep/ .el-input__inner:focus{
        border-color:#5680FA;
    }
    .code.el-button:hover {
        color: #5680FA;
        border:1px solid rgba(86, 128, 250,0.3);
    }
</style>
